import { RESET_STATE } from 'store/global/actions';

import { PROGRAM_LOAN_ACTION_TYPE } from '../actions';

const initialState = [];

const programLoanReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PROGRAM_LOAN_ACTION_TYPE.GET_PROGRAM_LOAN_TYPES:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default programLoanReducer;
